import React, { useState  } from "react";
import { useSearchParams } from "react-router-dom";

const apiUrl = process.env.REACT_APP_API_URL;

const LoginPage = () => {
  const [searchParams] = useSearchParams();
  const [isRedirecting, setIsRedirecting] = useState(false);

    const handleLoginRedirect = () => {
      const nextParam = searchParams.get("next") || "/";
      const backendLoginUrl = `${apiUrl}/login/?next=${encodeURIComponent(nextParam)}`;
      // Redirect to your backend's login endpoint
      console.log(`Redirecting to backend login: ${backendLoginUrl}`);
      setIsRedirecting(true);
      setTimeout(() => {
        window.location.href = backendLoginUrl;
      }, 100);    };

  return (
    <div>
      <p>Redirecting to login...</p>
      {!isRedirecting && (
        <button onClick={handleLoginRedirect}>Click here to login</button>
      )}
    </div>
  );
};

export default LoginPage;
